// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noDateShow[data-v-a2963b42]{position:absolute;top:0;left:0;background-color:hsla(0,0%,100%,.7);z-index:100;text-align:center;line-height:15.625vw}.line-wrapper[data-v-a2963b42],.noDateShow[data-v-a2963b42]{height:100%;width:100%}.line-content[data-v-a2963b42]{height:100%;width:79.948vw}", ""]);
// Exports
module.exports = exports;
